import { RouterProvider } from "react-router"
import { router } from "@/router/root.tsx"
import { LocalStorage } from "@/helpers/LocalStorage.ts"

LocalStorage.setDefaults()

export function App() {
  return <RouterProvider router={router} />
}
